import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    select: {
      background: '#F3F3F3',
      height: '4.8rem',
      borderRadius: 4,

      '& .MuiSelect-filled': {
        paddingTop: '1.4rem',
        paddingBottom: '1.5rem',
      },
    },
    loadingSelect: {
      width: '6rem',
    },
    herbicidesContainer: {
      margin: '.8rem 0 0 2rem',
      padding: 0,
      listStyle: 'none',

      '& p': {
        fontSize: '1.4rem',

        '& span': {
          fontWeight: 600,
        },
      },
    },
    divider: {
      margin: '1rem',
    },
  }),
)
